import { defineStore } from 'pinia';
import { v2Api } from '../api';

export const useV2Session = defineStore('v2Session', {
  state: () => ({ user: null, loaded: false }),
  getters: {
    isLoggedIn: (state) => Boolean(state.user),
    isAdmin: (state) => Boolean(state.user && state.user.isAdmin),
  },
  actions: {
    async fetchMe() {
      try {
        const { data } = await v2Api.get('/auth/me');
        this.user = data.data.user;
      } catch {
        this.user = null;
      } finally {
        this.loaded = true;
      }
    },
    async login(username, password) {
      const { data } = await v2Api.post('/auth/login', { username, password });
      this.user = data.data.user;
      this.loaded = true;
      return this.user;
    },
    async logout() {
      try {
        await v2Api.post('/auth/logout');
      } finally {
        this.user = null;
      }
    },
    clearUser() {
      this.user = null;
      this.loaded = true;
    },
    setUser(user) {
      this.user = user;
    },
  },
});
